<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content" slot="custom">
      <img :src="data.icon" class="red-packet1-img"/>
      <div class="container">
        <div class="container-table">
          <span class="amount">
            {{data.discountValue}}
          </span>
          <span class="unit">
            元
          </span>
        </div>
      </div>
      <div class="desc first">完成首笔借款可激活红包</div>
      <div class="desc second">激活有效期：{{ data.couponEndTime | date('YYYY/MM/DD日')}}</div>
      <nd-button class="withdraw" @click="handleButtonClick" 
                 v-stat="{
                   id: 50022,
                   args: {
                     target: 'DRAINAGE', // 新人活动
                     step: data.nextStep,
                     position: 1,
                     status: 1
                   },
                 }"
      >立即提现</nd-button>
      <div class="activity-detail" @click="handleTextButtonClick">
        活动详情 >
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    open () {
      this.visible = true
      setKey('DRAINAGE_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleButtonClick () {
      if (this.data.nextStep) {
        this.$router.push(this.nextNode())
      } else {
        this.$router.push('/user/login')
      }
    }, 
    nextNode () {
      switch (this.data.nextStep) {
        case 'OCR':
          return '/authentication/id'
        case 'INFO':
        case 'CREDIT':
          return '/authentication/base'
        case 'CREDIT_REVIEW':
          return `/authentication/result?applyNo=${this.data.relationId}`
        case 'LOAN':
          return '/withdraw/index'
        case 'LOANING':
        case 'LOAN_WAIT_VIP':
          return `/withdraw/result?loanApplyNo=${this.data.relationId}`
        default:
          return '/authentication/id'
      }
    },
    handleTextButtonClick () {
      this.$report({
        id: 10124,
        args: {
          target: 3,
          status: this.data.couponDetailType
        }
      })
      this.$router.push({
        path: '/activities/drainage',
        query: {
          loanPlatform: 'TMD',
          activeType: this.data.activeType,
          open: 1
        }
      })
    },
    show () {
      setKey('DRAINAGE_SHOW_TIME', Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: 'DRAINAGE', // 引流活动
          step: this.data.nextStep,
          status: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        position: relative;
        // background: url('./bg.png');
        // background-size: 100%;
        .red-packet1-img{
            width: 620px;
        height: 750px;
        border-radius: 30px;
        position: absolute;
        background-size: 100%;
        z-index: 1;
        }
        .activity-detail {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 53px;
            z-index: 2;
        }
        .container {
            position: absolute;
            z-index: 2;
            top: 290px;
            display: flex;
            justify-content:center;
            width:100%;
            &-table{
                width: 160px;
                text-align: center; 
            }
            .amount {
                display: inline-block;
                font-size: 48px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: #C42A2A;
                line-height: 34px;
                margin-left: -20px;
            }
            .unit {
                position: absolute;
                z-index: 2;
                display: inline-block;
                top: 10px;
                padding-left: 5px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #C42A2A;
                line-height: 34px;
            }
        }
        .desc {
            position: absolute;
            z-index: 2;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #AD4B28;
            line-height: 33px;
            left: 50%;
            transform: translateX(-50%);
        }
        .first {
            top: 430px;
        }
        .second {
            top: 465px;
        }
        .withdraw {
            position: absolute;
            z-index: 2;
            top: 540px;
            width: 440px;
            height: 80px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
        }
    }
}
</style>
